<template>
  <vue-drawing-canvas
    ref="VueCanvasDrawing"
    v-model:image="image"
    :stroke-type="strokeType"
    :fill-shape="fillShape"
    :eraser="eraser"
    :lineWidth="line"
    :color="color"
    :background-color="white"
    :styles="{
      border: 'solid 1px #000',
    }"
    :lock="disabled"
    :width="width"
    :height="height"
    :line-cap="lineCap"
    :line-join="lineJoin"
    :style="style"
    @mousemove="getCoordinate($event)"
  />
</template>

<script>
import VueDrawingCanvas from "vue-drawing-canvas";
// import VueDrawingCanvas from "../../services/vue-drawing-canvas";

export default {
  name: "Canvas",
  components: {
    VueDrawingCanvas,
  },
  props: {
    width: {
      type: Number,
      default: () => 182,
    },
    height: {
      type: Number,
      default: () => 29,
    },
    style: {
      type: String,
      default: () =>
        "bottom: 82px; left: 176px; width: 180px; height: 27px; border: 1px solid black;",
    },
    sendImg: {
      type: Boolean,
      default: () => false,
    },
  },
  watch: {
    sendImg: function (newVal, oldVal) {
      if (oldVal == false && newVal == true && !this.alreadySent) {
        this.$emit("img", this.$refs.VueCanvasDrawing.save());
        this.alreadySent = true;
      }
    },
  },
  data() {
    return {
      x: 0,
      y: 0,
      image: "",
      eraser: false,
      disabled: false,
      fillShape: false,
      line: 2,
      color: "#000000",
      strokeType: "dash",
      backgroundColor: "transparent",
      initialImage: [],
      imgsrc: "",
      lineCap: "round",
      lineJoin: "round",

      alreadySent: false,
    };
  },

  methods: {
    isEmpty() {
      return this.$refs.VueCanvasDrawing.isEmpty();
    },
    getImage() {
      return this.$refs.VueCanvasDrawing.save();
    },
    getCoordinate(event) {
      if (!this.$refs.VueCanvasDrawing) return;
      let coordinates = this.$refs.VueCanvasDrawing.getCoordinates(event);
      this.x = coordinates.x;
      this.y = coordinates.y;
    },
  },
  created() {
    this.alreadySent = false;
  },
};
</script>

<style scoped></style>
